import { apiV2 } from './api';

export const fetchUpgradeDetail = () => apiV2.get('/products/upgrade/');
export const fetchUpgradeConfirm = (payload) => apiV2.post('/subscriptions/subscription/upgrade/', payload);
export const fetchUpgradeNotification = (payload) => apiV2.post('/accounts/userprofile/notify-modal-upgrade/', payload);
